// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"254":"5ce3a0f4","268":"dc2f909d","375":"3d481cee","457":"7c5a3420","617":"7c5e49c4","638":"dbeac0cb"}[chunkId] + ".chunk.js";
};